/**
 * Small svg action button that opens the manual multi-row slicing modal.
 */
import React from 'react';

type HamburgerButtonProps = {
    x: number;
    y: number;
    onClick: () => void;
};

export default function HamburgerButton({ x, y, onClick }: HamburgerButtonProps) {
    return (
        <g
            className='svg-button'
            transform={`translate(${x}, 0)`}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
        >
            <circle cx={0} cy={y} r={10} fill='#444' />
            <line x1={-3.5} y1={y - 3} x2={3.5} y2={y - 3} stroke='#fff' strokeWidth={1.5} />
            <line x1={-3.5} y1={y} x2={3.5} y2={y} stroke='#fff' strokeWidth={1.5} />
            <line x1={-3.5} y1={y + 3} x2={3.5} y2={y + 3} stroke='#fff' strokeWidth={1.5} />
        </g>
    );
}
